"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableContainerBoxVariants = void 0;
var AvailableContainerBoxVariants;
(function (AvailableContainerBoxVariants) {
    AvailableContainerBoxVariants["Default"] = "Default";
    AvailableContainerBoxVariants["Reverse"] = "Reverse";
    AvailableContainerBoxVariants["ReverseWidescreen"] = "ReverseWidescreen";
    AvailableContainerBoxVariants["ReverseDesktop"] = "ReverseDesktop";
    AvailableContainerBoxVariants["ReverseTablet"] = "ReverseTablet";
    AvailableContainerBoxVariants["ReverseMobile"] = "ReverseMobile";
})(AvailableContainerBoxVariants = exports.AvailableContainerBoxVariants || (exports.AvailableContainerBoxVariants = {}));
//# sourceMappingURL=ContainerBoxInterface.js.map